<script setup lang="ts">
const { t } = useI18n()

const articles = [
  {
    id: 'smsExamples',
    name: 'Joséphine Padou',
    img: 'josephine.png',
    link: 'https://content.heypongo.com/marketing/CalendrierMarketing2024HeyPongo.pdf'
  },
  {
    id: 'tenRules',
    name: 'Victor Fillette',
    img: 'victor.png',
    link: 'https://www.heypongo.com/blog/10-commandements-campagne-sms'
  },
  {
    id: 'targetingAdvices',
    name: 'Victor Fillette',
    img: 'victor.png',
    link: 'https://www.heypongo.com/blog/comment-bien-cibler-ses-campagnes-sms'
  }
]
</script>

<template>
  <div class="overflow-hidden rounded-md border bg-white">
    <div class="p-6">
      <div class="py-6 text-center">
        <h2 class="text-lg font-medium text-foreground">
          {{ t(`pages.campaign.campaignCreatePage.articles.header.title`) }}
        </h2>
        <h3 class="text-lg text-muted-foreground">
          {{ t(`pages.campaign.campaignCreatePage.articles.header.description`) }}
        </h3>
      </div>
      <div class="flow-root">
        <ul class="flex flex-col gap-4 md:flex-row">
          <li
            v-for="article in articles"
            :key="article.id"
            class="mb-6 transform rounded-lg border p-4 transition-all hover:scale-105 md:w-1/3"
          >
            <a :href="article.link" target="_blank" class="mt-4 block">
              <p class="text-sm font-semibold text-foreground">
                {{ t(`pages.campaign.campaignCreatePage.articles.${article.id}.title`) }}
              </p>
              <p class="mt-3 text-xs text-muted-foreground">
                {{ t(`pages.campaign.campaignCreatePage.articles.${article.id}.description`) }}
              </p>
            </a>
            <div class="mt-6 flex items-center">
              <div class="shrink-0">
                <div>
                  <img class="h-8 w-8" :src="`/images/teamPongo/${article.img}`" alt="" />
                </div>
              </div>
              <div class="ml-3">
                <p class="text-xs font-medium text-foreground">
                  {{ article.name }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
